export const NECESSARY_COOKIES = {
  title: 'Necessary cookies',
  description: 'Allow core functionality like page navigation and access to secure areas.',
  linkedCategory: 'necessary',
  cookieTable: {
    caption: '',
    headers: {
      name: 'Name',
      domain: 'Domain',
      duration: 'Expiration',
      description: 'Description',
    },
    body: [
      // Amazon
      {
        name: 'AWSALBCORS',
        domain: 'aws.amazon.com',
        duration: '7 days',
        description: 'Amazon Web Services set this cookie for load balancing',
      },
      {
        name: 'AWSALB',
        domain: 'aws.amazon.com',
        duration: '7 days',
        description:
          'AWSALB is an application load balancer cookie set by Amazon Web Services to map the session to the target',
      },

      // Cloudflare
      {
        name: '__cflb',
        domain: 'cloudflare.com',
        duration: '23 hours',
        description:
          'The _cflb is a load balancing cookie provided by Cloudflare Inc. to assist with web traffic filtration, balance traffic loads, manage failovers and support network resource usage',
      },
      {
        name: '__cf_bm',
        domain: 'cloudflare.com',
        duration: '1 hour',
        description: 'This cookie, set by Cloudflare, is used to support Cloudflare Bot Management',
      },

      // Grecaptcha
      {
        name: '_GRECAPTCHA',
        domain: 'google.com',
        duration: '6 months',
        description:
          'Google Recaptcha service sets this cookie to identify bots to protect the website against malicious spam attacks',
      },

      // Digg
      {
        name: 'connect.sid',
        domain: 'digg.com',
        duration: 'past',
        description:
          'This cookie is used for authentication and for secure log-in. It registers the log-in information',
      },

      // ANY.RUN
      {
        name: 'x_mtok',
        domain: 'any.run',
        duration: '1 year 1 month 4 days',
        description: 'Used for a proper file uploading',
      },
      {
        name: 'tokenLogin',
        domain: 'any.run',
        duration: '14 days',
        description:
          "Used to store visitor's login credentials to save preferences, such as task preset configuration, task history and so on",
      },

      // TI
      {
        name: 'accessToken',
        domain: 'intelligence.any.run',
        duration: '30 minutes',
        description: 'Used to provide security features for Threat Intelligence',
      },
    ],
  },
};
